import moment from 'moment';

export default class KindergartenHoliday {

    constructor() {
        this.description = '';
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let holiday = new KindergartenHoliday();
        holiday.id = data.id;
        holiday.date = data.date;
        holiday.description = data.description;

        return holiday;
    }

    toData() {
        return {
            id: this.id,
            date: moment(this.date, 'YYYY-MM-DD').format('DD.MM.YYYY'),
            description: this.description
        };
    }

    serialize () {
        return {
            id: this.id,
            date: moment(this.date, 'DD.MM.YYYY').format('YYYY-MM-DD'),
            description: this.description
        };
    }

    isNotEmpty() {
        return this.date || this.description;
    }

    isValid() {
        return this.date && this.description;
    }
}
